import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

import { ContextMenu } from 'components/context-menu/context-menu';
import TableList from 'components/TableList';
import { CheckBoxSingle } from '../../components/checkboxes/check-box-single';
import * as LotActionTypes from '../constants';
import AddEditNote from '../Components/AddEditLotNote';
import { AppSettings } from '../../constants';

class ManageNotes extends Component {
    static propTypes = {
      dispatch: PropTypes.func,
      lotId: PropTypes.any,
      LotNotes: PropTypes.array
    }

    constructor(prop) {
      super(prop);
      this.state = {
        editItem: null
      };
    }

    componentDidMount() {
      this.props.dispatch({
        type: LotActionTypes.GET_LOT_NOTES_ASYNC,
        params: {
          lotId: this.props.lotId
        }
      });
    }

    customRenderBtnAction(item) {
      return <a className='glyphicon glyphicon-option-vertical cls-table-black-icon' onClick={(e) => { this.onContextMenu(e, item); }} />;
    }

    onClickEditNote = (e, item) => {
      e.preventDefault();
      this.toggleModal(item);
    }

    onClickDeleteNote = (e, item) => {
      e.preventDefault();
      this.props.dispatch({
        type: LotActionTypes.DELETE_LOT_NOTE_ASYNC,
        params: {
          lotId: this.props.lotId,
          id: item.id
        }
      });
    }

    onContextMenu = (e, item) => {
      var contextItem = [
        {
          title: 'Edit',
          icon: 'glyphicon glyphicon-pencil',
          event: () => {this.onClickEditNote(e, item);}
        }
        // {
        //   title: 'Delete',
        //   icon: 'glyphicon glyphicon-pencil',
        //   event: () => {this.onClickDeleteNote(e, item);}
        // }
      ];

      this.cxtMenu.state.event(e, item, contextItem);
    }

    customRenderDate = (item) => {
      if (item.resolutionDate) {
        return <span>{moment(item.resolutionDate).format('MM/DD/YYYY')}</span>;
      }
      return '';
    }

    updateNotes = (item, callback = true) => {
      this.props.dispatch({
        type: LotActionTypes.EDIT_LOT_NOTE_ASYNC,
        params: {
          lotId: this.props.lotId,
          id: item.id,
          params: item
        },
        callback: () => {if (callback) {this.toggleModal();}}
      });
    }

    addNewNotes = (item) => {
      this.props.dispatch({
        type: LotActionTypes.ADD_LOT_NOTE_ASYNC,
        params: {
          lotId: this.props.lotId,
          params: item
        },
        callback: this.toggleModal
      });
    }

    onSubmitModal = (item) => {
      if (this.state.editItem) {
        this.updateNotes(item);
      } else {
        this.addNewNotes(item);
      }
    }

    onChangeStatusNote(e, item, data, state) {
      if (state.checked) {
        this.updateNotes({...item, closed: true}, false);
      } else {
        this.updateNotes({...item, closed: false}, false);
      }
    }

    toggleModal = (editItem = null) => {
      this.setState({ isOpenAddEditNoteModal: !this.state.isOpenAddEditNoteModal, editItem });
    }

    customRenderStatus = (item) => {
      return (
        <span>
          <CheckBoxSingle
            checked={item.closed}
            ref={c => { this.statusNote = c; }}
            onChecked={(e, data, state) => this.onChangeStatusNote(e, item, data, state)}
            isRebind='true'
            value={item.id}
            name={'status-note-' + item.id}
            className='checkbox-default ckb-fromHomeOwner' />
        </span>
      );
    }

    render() {
      const data = this.props.LotNotes || [];
      const column = [
        { field: 'homeowner.id', header: 'id', hidden: true, isKey: true, sort: false, dataAlign: 'left', headerAlign: 'left' },
        { field: 'note', header: 'Note', hidden: false, isKey: false, sort: false, dataAlign: 'left', headerAlign: 'left'},
        { field: 'resolution', header: 'Resolution', hidden: false, isKey: false, sort: false, dataAlign: 'left', headerAlign: 'left'},
        { field: 'resolutionDate', header: 'Resolution date', hidden: false, isKey: false, sort: false, dataAlign: 'right', headerAlign: 'right',
          customRender: this.customRenderDate},
        { field: 'status', header: 'Closed', hidden: false, isKey: false, sort: false, dataAlign: 'left', headerAlign: 'left',
          customRender: this.customRenderStatus},
        {
          field: '', header: '', hidden: false, isKey: false, sort: false, dataAlign: 'right', headerAlign: 'right',
          customRender: this.customRenderBtnAction.bind(this), className: 'column-action', columnClassName: 'column-action'
        }
      ];
      const options = {
        defaultSortName: 'purchaseDate',
        defaultSortOrder: 'descending'
      };
      return <div className='ownership-history-wrapper'>
        <div className='page-title clearfix'>
          {AppSettings.clientTypeValue === 'Builder' &&
            <button
              className='btn btn-primary btn-info btn-siteone pull-left btn-icon'
              onClick={() => this.toggleModal()}>NEW</button>
          }
        </div>
        <TableList
          column={column}
          defaultParams={options}
          data={data}
          options={options}
          pagination={false}
        />
        <ContextMenu ref={(ref) => { this.cxtMenu = ref; }} />
        {this.state.isOpenAddEditNoteModal && <AddEditNote onSubmit={this.onSubmitModal} onCloseModal={this.toggleModal} editItem={this.state.editItem} />}
      </div>;
    }
}

const mapStateToProps = (state) => {
  return {
    LotNotes: state.LotStore.LotNotes
  };
};

export default connect(mapStateToProps)(ManageNotes);




// WEBPACK FOOTER //
// ./src/Lots/Components/ManageNotes.js